//#region src/donation_round_up_prompt_type.ts
let DonationRoundUpPromptType = /* @__PURE__ */ function(DonationRoundUpPromptType) {
	DonationRoundUpPromptType["None"] = "none";
	DonationRoundUpPromptType["Custom"] = "custom";
	DonationRoundUpPromptType["Predefined"] = "predefined";
	return DonationRoundUpPromptType;
}({});
//#endregion
export { DonationRoundUpPromptType };

//# sourceMappingURL=donation_round_up_prompt_type.js.map